import { useEffect, useMemo, useState } from "react";

const mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)")
const initialDarkMode = mediaQueryList.matches

const useDarkMode = (override = undefined) => {
  const [matches, setMatches] = useState(initialDarkMode);
  const darkMode = useMemo(() => {
    return typeof override === 'boolean' ? override : matches
  }, [override, matches])

  useEffect(() => {
    const listener = (event) => {
      setMatches(event.matches)
    }

    mediaQueryList.addEventListener("change", listener);

    return () => {
      mediaQueryList.removeEventListener("change", listener);
    };
  }, [])
  
  return {
    darkMode
  };
};

export default useDarkMode;
